var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isBannerOfTypeText)?[_vm._v(" Impossible d'ajouter des images pour une bannière du type texte. ")]:[_c('display-banner-images',{ref:"imageDisplay",attrs:{"banner-id":_vm.bannerId}}),_c('upload-banner-images',{staticClass:"mt-4",attrs:{"banner-id":_vm.bannerId},on:{"uploaded":_vm.onImagesUploaded}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }